(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/list.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/list.js');
"use strict";


const Hr = svs.tickets_giftshop.components.HR;
const _svs$tickets_giftshop = svs.tickets_giftshop.gift.giftform.cart.components,
  Item = _svs$tickets_giftshop.Item,
  Empty = _svs$tickets_giftshop.Empty;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.constants.cart,
  SET = _svs$tickets_giftshop2.SET,
  APPEND = _svs$tickets_giftshop2.APPEND;
const getCart = svs.tickets_giftshop.gift.giftform.cart.getters.getCart;
const List = _ref => {
  let _ref$cart = _ref.cart,
    cart = _ref$cart === void 0 ? [] : _ref$cart;
  return React.createElement("div", {
    className: "tg-cart-list"
  }, cart.length ? cart.map(_ref2 => {
    let amount = _ref2.amount,
      product = _ref2.product,
      isAnimatingOnRender = _ref2.isAnimatingOnRender,
      lastUpdatedFromType = _ref2.lastUpdatedFromType;
    const productId = product.productId,
      productVariation = product.productVariation,
      type = product.type,
      skinId = product.skinId;
    return React.createElement(React.Fragment, {
      key: "tg-cart-item-".concat(productId, "_").concat(productVariation, "_").concat(type, "_").concat(skinId)
    }, React.createElement(Item, {
      amount: amount,
      isAnimatingOnRender: isAnimatingOnRender,
      lastUpdatedFromType: lastUpdatedFromType,
      product: product
    }), React.createElement(Hr, null));
  }) : React.createElement(Empty, null));
};
const mapStateToProps = state => {
  const _getCart = getCart(state),
    cart = _getCart.cart,
    error = _getCart.error;
  return {
    cart,
    error
  };
};
svs.tickets_giftshop.gift.giftform.cart.components.List = ReactRedux.connect(mapStateToProps)(List);

 })(window);